var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function parseRequired(form) {
  var parsed = [];
  for (var _iterator = form, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var row = _ref;

    for (var _iterator2 = row, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var field = _ref2;

      for (var _iterator3 = createChecks(field), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray3) {
          if (_i3 >= _iterator3.length) break;
          _ref3 = _iterator3[_i3++];
        } else {
          _i3 = _iterator3.next();
          if (_i3.done) break;
          _ref3 = _i3.value;
        }

        var check = _ref3;

        parsed.push(check);
      }
    }
  }
  return parsed;
}

function createChecks(field) {
  var getMessage = function getMessage(field) {
    return field.message || 'Please enter your ' + field.label.toLowerCase();
  };

  // If not required, then don't create a check
  if (!field || !field.required) {
    return [];
  }

  // Format into objecs if we defined what we're checking explicitly
  if (field.required instanceof Array) {
    return field.required.map(function (req) {
      return _extends({}, req, {
        message: getMessage(req)
      });
    });
  }

  // Parse recursively and add a conditional clause
  if (field.expansion) {
    var checks = parseRequired(field.expansion).map(function (check) {
      return _extends({
        only_if: {
          name: field.name + '::expanded',
          value: 'yes'
        }
      }, check);
    });

    if (field.label || field.message) {
      checks.push({
        message: getMessage(field),
        name: field.name
      });
    }

    return checks;
  }

  // If we want to derive it from the field
  return [{
    message: getMessage(field),
    name: field.name
  }];
}

export default parseRequired;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/parseRequired.js
// module id = 267
// module chunks = 0